import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DropdownItems } from '@material-library';
import { Subscription } from 'rxjs';
import { ZuoraAccountService } from 'src/app/account/services/zuora-account.service';
import { ApiService } from 'src/app/core/api.service';
import { MultiAdminService } from 'src/app/core/multiadmin.service';
import { SyncCookieService } from 'src/app/core/sync-cookie.service';
import { UserService } from 'src/app/core/user.service';
import { BlendEvent, OrderSessionNewApiOutput } from 'src/app/shared/models';
import { zAccountInfo } from 'src/app/shared/models/api/orderprofile-api.model';
import { PlanDetailsApiOutput } from 'src/app/shared/models/api/plandetails.model';
import { DialogWrapper } from 'src/app/shared/services/DialogWrapper';
import { BlendService } from 'src/app/shared/services/blend.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { environment } from 'src/environments/environment';

@Component({
    templateUrl: './purchase-users.component.html',
    styleUrls: ['./purchase-users.component.scss'],
})
export class PurchaseUsersComponent extends DialogWrapper implements OnInit, OnDestroy {
    public selectedValue = '1';
    public options: DropdownItems[]
    public isLoading = false;
    private zuoraSubscription: Subscription;

    constructor(
        public dialogRef: MatDialogRef<PurchaseUsersComponent>,
        @Inject(MAT_DIALOG_DATA) public matDialogData: {},
        private api: ApiService,
        private userService: UserService,
        private zuora: ZuoraAccountService,
        private syncCookie: SyncCookieService,
        private router: Router,
        private snackbarService: SnackbarService,
        private multiadminService: MultiAdminService,
        private blendService: BlendService
    ) {
        super();
    }
    
    async ngOnInit() {
        this.isLoading = true;
        const result = await this.multiadminService.getUserList();
        this.options = Array.from({ length: 300 -  result.user_limit}, (_, i) => ({ name: (i + 1).toString(), value: (i + 1).toString() }));
        this.isLoading = false;
    }
    
    ngOnDestroy(): void {
        if (this.zuoraSubscription) {
            this.zuoraSubscription.unsubscribe();
        }
    }

    // Handlers
    public onSelectionChange = (value): void => {
        this.selectedValue = value.value;
    }

    public onActionClick = async () => {
        try {
            this.blendService.track(BlendEvent.BUTTON_CLICKED, {button_text: 'Add Licenses', num: +this.selectedValue});
            const plan = await this.api.execute<PlanDetailsApiOutput>('getPlanDetails', {});
            const p = plan.plan_product_id;
            const rp = plan.plan_rate_plan_id;
            const rpc = plan.plan_rate_plan_charge_id;
            const qty = plan.plan_user_limit;
            const isMultiNew = this.userService.get('is_multi_new');
            const isMultiAdmin = this.userService.get('is_multi_admin');
            const zprofile: zAccountInfo = await new Promise((resolve) => {
                this.zuoraSubscription = this.zuora.getSubscription().subscribe(data => {
                  if (data.isLoaded) {
                    resolve(data.zprofile);
                  }
                });
              });
    
            if ((isMultiNew || (!isMultiNew && isMultiAdmin)) && zprofile && zprofile.balance <= 0 && zprofile.unpaidInvoiceCount >= 0) {
                const result = await this.api.execute<OrderSessionNewApiOutput>('ordersessionnew', {});
                this.syncCookie.setOrderSessionId(result.sessionId);
                const url = environment.ordershost
                    + '/upgrade/'
                    + p
                    + '?rp=' + rp
                    + '&rpc=' + rpc
                    + '&qty=' + (qty + parseInt(this.selectedValue));
                this.redirectTo(url);
            }
            else {
                this.router.navigate(['/account/upgrade']);
            }
        }
        catch (ex) {
            this.snackbarService.showMessage('critical', 'Failed to create order session');
        }
    }

    protected redirectTo(url: string): void {
        window.location.href = url;
    }
}